module.exports = __webpack_public_path__ + "static/media/Project-dashboard.867d4842.png";